import { useMemo } from 'react';

import { Box, type SxProps, type Theme, useTheme } from '@mui/material';

import { parseMarkdown } from '@modules/_shared/utils/parseMarkdown';

type Props = {
  children: string;
  sx?: SxProps<Theme>;
};

export const MarkdownRenderer = ({ children, sx }: Props) => {
  const theme = useTheme();
  const palette = (theme.vars ?? theme).palette;
  const html = useMemo(() => {
    return parseMarkdown(children, { openLinksInNewTab: true });
  }, [children]);
  return (
    <Box
      sx={{
        wordWrap: 'break-word',
        overflowWrap: 'break-word',
        wordBreak: 'break-word',
        '& > *:first-of-type': {
          marginTop: 0,
        },
        '& *:last-child': {
          marginBottom: 0,
        },
        '& a': {
          color: palette.primary.main,
          textDecoration: 'none',
        },
        '& p': { m: 0, mb: 0.5 },
        '& p:last-child': { mb: 0 },
        '& p:empty::before': {
          content: '"\\00a0"',
        },
        '& ul': { m: 0, pl: 2.5, listStyleType: 'disc' },
        '& ul ul': { listStyleType: 'circle' },
        '& ol': { m: 0, pl: 2.5 },
        '& li': { mb: 0.25 },
        '& li:last-child': { mb: 0 },
        ...sx,
      }}
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
};
